import { render, staticRenderFns } from "./Deuna.vue?vue&type=template&id=298f9bae&scoped=true"
import script from "./Deuna.vue?vue&type=script&lang=ts"
export * from "./Deuna.vue?vue&type=script&lang=ts"
import style0 from "./Deuna.vue?vue&type=style&index=0&id=298f9bae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f9bae",
  null
  
)

export default component.exports